<template>
  <section class="multiple-choice">
    <div v-if="pageType === 'single'" class="left title">
      <span class="isRequred" v-if="isRequired">*</span>
      <span v-if="isShowNumber == 1">{{ qNo }}</span>
    </div>
    <div class="right">
      <div class="title" v-if="question.subject_title_type == 1">
        <span class="multiple">[多选]</span>
        <span class="pure-text">{{
          question.title_quote_title_num !== 0 ? optionsTitle : question.subject
        }}</span>
      </div>
      <div v-else>
        <rich-text
          :type="2"
          :content="
            question.title_quote_title_num !== 0
              ? optionsTitle
              : question.subject
          "
        />
      </div>
      <div class="tips">{{ multiChoiceTips }}</div>
      <div class="answer-list">
        <div
          v-if="
            question.option_quote_title_num !== 0 && answerList.length === 0
          "
        >
          本题选项源于前边题目的选项
        </div>
        <div e-else v-for="(item, idx) in answerList" :key="idx">
          <div class="answer-item" @click="hanleSelect(item, idx)">
            <check-box size="big" class="mr-8" :checked="item.checked" />
            <rich-text :type="2" :content="item.option" />
          </div>
          <InputComps
            v-if="item.is_empty == 1 && item.checked"
            :value="item.details"
            :isRequired="item.is_required == 1"
            @change="handleInputChange($event, idx)"
          ></InputComps>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 多选题组件
 */
import CheckBox from '@/components/checkbox';
import RichText from '@/components/rich-text';
import InputComps from './input.vue';

export default {
  name: 'MultipleChoice',
  components: { CheckBox, RichText, InputComps },
  props: {
    isShowNumber: {
      //是否显示序号
      type: Number,
      default: 0,
    },
    pageType: {
      type: String,
      default: 'single', // 默认单页展示
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    titleNo: {
      type: Number, // 当前题目序号
      default: 0,
    },
    question: {
      type: Object,
      default: () => {},
    },
    answer_json: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      qNo: this.titleNo < 9 ? `0${this.titleNo}` : this.titleNo, // 问题序号
      answerList: [],
      multiChoiceTips: '', // 多选提示文案
      min: 0, // 做少选中
      max: 0, // 做多选中
    };
  },
  mounted() {
    this.max = this.question?.option_set?.max;
    this.min = this.question?.option_set?.min;
    const choice = this.question?.option || [];

    // 组装问题列表
    this.answerList = choice.map((v) => {
      return {
        ...v,
        checked: false,
        details: '',
      };
    });
    this.createMultiTips();
  },
  methods: {
    // 组装多选题提示文案
    createMultiTips() {
      // 最少不限、最多不限
      if (this.min === 0 && this.max === this.answerList.length) {
        this.multiChoiceTips = '';
        return;
      }
      if (this.min === 0) {
        this.multiChoiceTips = `(最多选择${this.max}项)`;
        return;
      }
      if (this.max === this.answerList.length) {
        this.multiChoiceTips = `(最少选择${this.min}项)`;
        return;
      }
      this.multiChoiceTips = `(请选择${this.min}-${this.max}个选项)`;
    },
    // 选中逻辑
    hanleSelect(item, idx) {
      // option_key other：其他选项（只会有一个其他选项） 否则：普通选项
      // 当前选项为选中状态
      if (item.checked) {
        this.answerList[idx].checked = false;
      } else {
        // max最大限制，如果已经选中max数量
        const maxlen = this.answerList.filter((v) => v.checked).length;
        if (maxlen >= this.max) {
          this.$hll.toast(`本题最多支持选择${this.max}项`);
          return;
        }
        // 选中其他选项
        if (item.option_key === 'other') {
          // 将所有置成FALSE
          for (const item of this.answerList) {
            item.checked = false;
          }
        } else {
          // 选中普通选项，只需将其他选项变成FALSE
          const eIndex = this.answerList.findIndex(
            (v) => v.option_key === 'other',
          );
          if (eIndex >= 0) {
            this.answerList[eIndex].checked = false;
          }
        }
        this.answerList[idx].checked = true;
      }
      // 提交结果
      this.handleSubmit();
    },
    // 提交结果
    handleSubmit() {
      // 组装提交答案结构
      const answer = this.answerList
        .filter((v) => v.checked)
        .map((item) => {
          return {
            ...item, // 透传所有 option 的值
            option_name: item.option, // 添加名称传过去
            option: item.option_key,
            details: item.details,
            is_empty: item.is_empty,
            is_required: item.is_required ? 1 : 0,
          };
        });
      this.$emit('change', answer, this.index, this.question);
    },
    // 输入选项填空
    handleInputChange(value, idx) {
      this.answerList[idx].details = value;
      this.handleSubmit();
    },
  },
  computed: {
    // 选项引用前题选项的前题
    preQuestion() {
      return this.answer_json[this.question.option_quote_title_num - 1];
    },
    // 标题引用前题选项
    optionsTitle() {
      const preQuestion =
        this.answer_json[this.question.title_quote_title_num - 1];
      console.log('preQuestion');
      console.log(preQuestion);
      if (this.question.title_quote_title_num !== 0 && preQuestion) {
        let optionsNames = '';
        // 判断题 量表题 打分题取同层的 option_name
        if ([3, 4, 5].includes(preQuestion.subject_type)) {
          optionsNames = preQuestion.option;
          if (preQuestion.subject_type === 3) {
            optionsNames = preQuestion.option_name || '';
          }
        } else {
          optionsNames = preQuestion.option
            .map((item) => item.option_name)
            .join(' ');
        }
        return this.question.subject.replace(/【.*?】/, optionsNames);
        // return '【】'
      } else {
        return this.question.subject.replace(/【.*?】/, '');
      }
    },
  },
  watch: {
    preQuestion: {
      deep: true,
      handler: function (val, oldVal) {
        if (this.question.option_quote_title_num !== 0) {
          this.answerList = this.answer_json[
            this.question.option_quote_title_num - 1
          ].option.map((item) => {
            const result = {
              ...item,
              option: item.option_name,
              checked: false,
              details: '',
            };
            delete result.option_name;
            return result;
          });
        }
      },
    },
    answerList: {
      deep: true,
      handler: function () {
        this.handleSubmit();
      },
    },
  },
};
</script>

<style lang="less" scoped>
.multiple-choice {
  display: flex;
  .isRequred {
    color: #ff3b30;
    font-size: 18px;
  }
  .multiple {
    color: #ff6600;
    margin-right: 4px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 25px;
  }
  .left {
    width: 30px;
    margin-right: 8px;
    text-align: right;
  }
  .tips {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    margin-top: 6px;
  }
  .right {
    flex: 1;
    .answer-item {
      margin-top: 20px;
      display: flex;
      align-items: center;
      .answer-text {
        margin-left: 8px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
}
</style>
